import appRoutes from '@/apps/unrealos/core/routes';
import IconifyIcon from '@/components/IconifyIcon';
import { Link } from '@/components/Link';
import { Box, Container, Typography } from '@mui/material';

import data from './data';

import type { PageData } from './types';

const View = () => {
    return (
        <Box>
            <Container maxWidth="xl">
                <Box sx={{
                    py: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                }}>
                    <Box>
                        <Typography variant="h1" align="center" gutterBottom>
                            Solutions
                        </Typography>
                        <Typography variant="body1" align="center" gutterBottom>
                            We provide a wide range of services to help you grow your business.
                        </Typography>
                    </Box>

                    <ItemsList list={data} />
                </Box>
            </Container>
        </Box>
    )
}


interface ItemsListProps {
    list: PageData[]
}
const ItemsList = ({ list }: ItemsListProps) => {
    return (
        <Box>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: {
                    xs: 5,
                    md: 10,
                },
            }}>
                {list.map((item, index) => (
                    <Link
                        key={index}
                        href={appRoutes.solutions.detail.as({ slug: item.slug })}
                        sx={{
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'transparent',
                            color: 'text.primary',
                            transition: 'all 0.2s ease-in-out',
                            p: 10,
                            '&:hover': {
                                borderColor: 'primary.light',
                            }
                        }}>
                        <Box sx={{
                            color: 'primary.light',
                        }}>
                            {item.icon && (
                                <IconifyIcon icon={item.icon} width={40} height={40} />
                            )}
                        </Box>
                        <Box sx={{
                            mt: 3,
                        }}>
                            <Typography variant="h6" component="h3" gutterBottom>
                                {item.title}
                            </Typography>
                            {item.description ? (
                                <Typography variant="body2" component="p">
                                    {item.description}
                                </Typography>
                            ) : ''}
                        </Box>
                    </Link>

                ))}
            </Box>
        </Box>
    )
}

export default View;